export enum UserWidgetType {
  DEAL_CONTINGENT = 'deal_contingent',
  RATES_DEAL_CONTINGENT = 'rates_deal_contingent',
  IRA = 'ira',
}
